// extracted by mini-css-extract-plugin
export default {"NoContacts":"styles_NoContacts__9V9GF","message":"styles_message__h-Y-d"};